export const VACCINE_TYPE_PARAM = "vaccin"

/**
 * Appends the vaccine filter without clobbering a query string the CMS link may already carry.
 *
 * The clinics overview reads this param and pre-filters to that vaccine, so arriving from a
 * specific vaccine's page shows only the clinics that offer it. An empty slug returns the href
 * untouched — a listing page has no single vaccine to filter by, and `?vaccin=` would filter to
 * nothing rather than to everything.
 */
export const withVaccineFilter = (href: string, slug?: string) => {
  if (!slug || !href || href === "#") return href

  // Only our own clinics overview reads this param, and both call sites take a CMS link an editor
  // can repoint anywhere — an external booking site, an onelink, a mailto:. Appending there is a
  // no-op at best and corrupts the link at worst, so anything off-site is left alone. `urlParser`
  // has already made internal links absolute against HOME_URL by this point.
  const home = process.env.HOME_URL
  if (!href.startsWith("/") && !(home && href.startsWith(home))) return href

  // Split the hash off first and re-attach it last: a query appended after the fragment
  // (".../mottagningar#boka?vaccin=tbe") is read as part of the fragment, so the page sees no filter.
  const hashAt = href.indexOf("#")
  const beforeHash = hashAt === -1 ? href : href.slice(0, hashAt)
  const hash = hashAt === -1 ? "" : href.slice(hashAt)

  // `set`, not append: a link that already carries `?vaccin=` would otherwise end up with two, and
  // `searchParams.get` returns the first — so the CMS value would silently win over this page's own.
  const queryAt = beforeHash.indexOf("?")
  const path = queryAt === -1 ? beforeHash : beforeHash.slice(0, queryAt)
  const params = new URLSearchParams(queryAt === -1 ? "" : beforeHash.slice(queryAt + 1))
  params.set(VACCINE_TYPE_PARAM, slug)

  return `${path}?${params}${hash}`
}
